import styled from 'styled-components'

export const Content = styled.div`
    text-align: center;

    @media (min-width: 1025px) {
        padding: 0 15%;
    }
`